// extracted by mini-css-extract-plugin
module.exports = {"storylyGroup":"storyly-group_storylyGroup__2mT17","header":"storyly-group_header__1-suK"};